import React from 'react';
import './SocialMediaSection.css';
import { UnderlinedText, Button } from '../shared';
// Issue #443 — social-media section logo updated to the new logo (transparent PNG).
import logo from '../../assets/Universe_Logo_new.png';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Social Media Section component
 * Displays branding and social media links
 */
const SocialMediaSection = () => {
  const { t } = useLanguage();

  return (
    <section className="social-section" aria-labelledby="social-heading">
      <div className="social-section-container">
        <div className="social-section-content">
          {/* Logo */}
          <div className="social-section-logo" aria-hidden="true">
            <img
              src={logo}
              alt=""
              className="social-section-logo-image"
            />
          </div>

          {/* Tagline */}
          <div className="social-section-text-block">
            <h2 id="social-heading" className="social-section-title">
              <UnderlinedText textColor="#ffffff" showUnderline={false}>{t('social.titleStart')}</UnderlinedText>{' '}{t('social.titleHighlight')}{' '}<UnderlinedText textColor="#ffffff" showUnderline={false}>{t('social.titleMiddle')}</UnderlinedText>{' '}{t('social.titleHighlight2')}{t('social.titleEnd') ? <>{' '}<UnderlinedText textColor="#ffffff" showUnderline={false}>{t('social.titleEnd')}</UnderlinedText></> : null}
            </h2>
          </div>

          {/* Instagram CTA */}
          <p className="social-section-cta">
            {t('social.cta')}
          </p>

          {/* Instagram CTA Button */}
          <Button
            variant="light"
            size="large"
            href="https://www.instagram.com/universe_student_app/"
            target="_blank"
            rel="noopener noreferrer"
            leadingIcon={
              <svg
                width="24"
                height="24"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="46"
                  height="46"
                  rx="12"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <circle
                  cx="25"
                  cy="25"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <circle
                  cx="38"
                  cy="12"
                  r="3"
                  fill="currentColor"
                />
              </svg>
            }
          >
            {t('social.instagramCta')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaSection;
